import { render, staticRenderFns } from "./CoozzyReminderIcon.vue?vue&type=template&id=2f3c3cbe&scoped=true"
import script from "./CoozzyReminderIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyReminderIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyReminderIcon.vue?vue&type=style&index=0&id=2f3c3cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c3cbe",
  null
  
)

export default component.exports